// 获取首页banner上的基础数据
import { requestGet } from '@/services/request';

export async function apiGetBasicData() {
  return requestGet('/v1/cert/index/stats', {});
}
